/*
 * Mobile-only swipeable product photo slider for product cards (collections pages).
 * Native CSS scroll-snap handles the swipe gesture; this script:
 *  - keeps the pagination dots in sync
 *  - restores "tap image to open the product" (the slider sits above the
 *    full-card <a class="card__url"> overlay so it can receive the swipe,
 *    which also means it now blocks that link from being tapped directly)
 *  - keeps the color-swatch thumbnails in sync with the slider, jumping to
 *    each color's first photo (colors can have different photo counts now
 *    that the slider shows every photo, not just one per color), since the
 *    theme's own swatch click handler updates the (now hidden-on-mobile)
 *    .media image, which no longer has any visible effect
 *  - re-scans the page when new cards are injected (infinite scroll / filters)
 * ADDED BY CLAUDE.
 */
(function () {
  if (window.__choCardSliderLoaded) return;
  window.__choCardSliderLoaded = true;

  function setupDots(track) {
    var wrapper = track.closest('.card__mobile-slider');
    var dotsWrap = wrapper ? wrapper.querySelector('.card__mobile-slider-dots') : null;
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];
    if (!dots.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var slides = Array.prototype.slice.call(track.children);
          var idx = slides.indexOf(entry.target);
          if (idx < 0) return;
          dots.forEach(function (dot, i) {
            dot.classList.toggle('card__mobile-dot--active', i === idx);
          });
        });
      },
      { root: track, threshold: 0.6 }
    );

    Array.prototype.slice.call(track.children).forEach(function (slide) {
      observer.observe(slide);
    });
  }

  function setupTapThrough(track, cardWrapper) {
    // A plain "click" only fires on a genuine tap, not on a swipe/scroll
    // gesture inside a scrollable element — browsers suppress it once the
    // touch has caused scrolling. So this only ever fires for real taps.
    track.addEventListener('click', function () {
      var link = cardWrapper && cardWrapper.querySelector('.card__url');
      if (link && link.getAttribute('href')) window.location.href = link.href;
    });
  }

  function setupSwatchSync(cardWrapper, track) {
    // Each color now has its own full photo gallery in the slider (not one
    // slide per color), so a swatch can't just jump to "its own index" —
    // it jumps to the first slide of its color's group instead, using the
    // starting index the liquid template stamped onto it.
    var swatches = cardWrapper.querySelectorAll('.card__images .card__option-image');
    if (!swatches.length) return;

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var startIdx = parseInt(swatch.dataset.sliderStart, 10);
        if (isNaN(startIdx)) return;
        var slide = track.children[startIdx];
        if (slide) {
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      });
    });
  }

  function setupTrack(track) {
    if (!track || track.dataset.choSliderInit) return;
    track.dataset.choSliderInit = '1';

    setupDots(track);

    var cardWrapper = track.closest('.card-wrapper');
    if (cardWrapper) {
      setupTapThrough(track, cardWrapper);
      setupSwatchSync(cardWrapper, track);
    }
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.card__mobile-slider-track').forEach(setupTrack);
  }

  function init() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scan(node);
      });
    });
  });

  if (document.body) {
    mo.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      mo.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
